export default function MatchApi({ makeRequest, buildRequest, baseUrl = '' }) {
    
   function autoMatchTransactions() {
        return buildRequest().then(function (req) {
            return makeRequest(req.post(`${baseUrl}/match/all`));
        });
    }

    function getChildMatches() {
        return buildRequest().then(function (req) {
            return makeRequest(req.get(`${baseUrl}/match/all`));
        });
    }

    function updateChildMatch(data) {
        return buildRequest().then(function (req) {
            return makeRequest(req.put(`${baseUrl}/match/upsert`, data));
        });
    }

    function deleteChildMatch(id) {
        return buildRequest().then(function (req) {
            return makeRequest(req.delete(`${baseUrl}/match?id=${id}`));
        });
    }

    return {
        autoMatchTransactions,
        getChildMatches,
        updateChildMatch,
        deleteChildMatch
    }

}